import {
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit'
import { regions } from './data_types'
import { filterRegionsByAvailability, getInitialRegion } from './functions'
import { Region } from './types'

export const regionsAdapter = createEntityAdapter<Region>()

export const createInitialRegionsState = (availableRegionIds?: string) => {
  const availableRegions = filterRegionsByAvailability(availableRegionIds)
  const extraState: { selectedId: keyof typeof regions | null } = {
    selectedId: getInitialRegion(availableRegions)
  }
  return regionsAdapter.setAll(
    regionsAdapter.getInitialState(extraState),
    availableRegions
  )
}

export const initialRegionsState = createInitialRegionsState()

export const regionsSlice = createSlice({
  name: 'region',
  initialState: initialRegionsState,
  reducers: {
    setSelectedRegionId: (
      state,
      action: PayloadAction<keyof typeof regions | null>
    ) => {
      localStorage.setItem('selectedRegionId', action.payload ?? '')
      // Set query parameter without reloading the page
      const url = new URL(window.location.href)
      if (action.payload) {
        url.searchParams.set('region', action.payload)
      } else {
        url.searchParams.delete('region')
      }
      window.history.replaceState({}, '', url.toString())
      state.selectedId = action.payload
    }
  }
})

export const reducer = regionsSlice.reducer

export const { setSelectedRegionId } = regionsSlice.actions
